import React from 'react';
import styled from '@xstyled/styled-components';
import { Item, registry, RenderProps } from '../Item';
import { CHART_LINE } from '../itemIds';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartData
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

interface ItemDef {
  title: string;
  subtitle: string;
  body: string;
}

interface Props {
  title?: string;
  subtitle?: string;
  items: Array<ItemDef>;
}

const Wrapper = styled.divBox`
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  padding-bottom: 30px;
  width: 100%;
`;

export class ChartLine extends Item<typeof CHART_LINE, Props> {
  protected render({ title, subtitle, items }: RenderProps<Props>) {
    const labels: string[] = [];
    const ariaLabel: string[] = [];

    const options = {
      responsive: true,
      plugins: {
        legend: {
          position: 'top' as const
        },
        title: {
          display: false
        }
      }
    };

    const dataSets: Record<string, unknown>[] = [];

    if (items && items.length) {
      items.forEach((item: ItemDef, index) => {
        // labels.push(`Dataset ${index+1}`);
        labels.push('');
        ariaLabel.push(`${item?.title}: ${item?.subtitle}`);

        const colors = item?.body?.replace(/<\/?[^>]+(>|$)/g, '')?.split(',');

        dataSets.push({
          label: item?.title,
          data: item?.subtitle.split('|'),
          borderColor: colors && colors[0] ? colors[0] : 'rgb(53, 162, 235)',
          backgroundColor:
            colors && colors[1] ? colors[1] : 'rgba(255, 99, 132, 0.5)'
        });
      });
    }

    const data = { labels, datasets: dataSets } as unknown as ChartData<'line'>;

    return (
      <Wrapper>
        <Line options={options} data={data} />
      </Wrapper>
    );
  }
}

registry[CHART_LINE] = ChartLine;
